import { Component } from '@angular/core';
import { WebCoreIoCKeys, IEventHandler, IoCContainer, ISettingsStorage } from '@lmnop/web-core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'reset-default-settings-control',
    templateUrl: 'reset-default-settings.control.html',
    standalone: false,
})
export class ResetDefaultSettingsControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
        this.onResetDefaultSettings = this.ioc.core.eventHandler;
    }

    public static RESET_DEFAULT_SETTINGS_EVENT: string = 'reset_default_settings';

    public onResetDefaultSettings: IEventHandler;

    public onResetClick(): void {
        let settingsStorage: ISettingsStorage = IoCContainer.get(WebCoreIoCKeys.ISettingsStorage);
        settingsStorage.resetAllModuleSettingsWithDefaultValues().then((): void => {
            this.onResetDefaultSettings.emit(ResetDefaultSettingsControl.RESET_DEFAULT_SETTINGS_EVENT);
        });
    }
}
